<script setup lang="ts">
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { usePlanDialogStore } from '@/shared/stores/planDialog';
import UpdatePlanDialog from '@/features/company-settings/components/UpdatePlanDialog.vue';

const store = usePlanDialogStore();
const route = useRoute();

const dialogVisible = computed({
  get: () => store.show,
  set: (val: boolean) => {
    if (!val) store.onClose();
  },
});

function handlePlanUpdated(payload: { plan: string; duration: string; addEntities: number; amount: number; isMonthly: boolean }) {
  store.onPlanUpdated(payload);
}

// 라우트 전환 시 열린 다이얼로그 정리 (GlobalDialog.vue 패턴)
watch(() => route.fullPath, () => {
  if (store.show) {
    store.onClose();
  }
});
</script>

<template>
  <UpdatePlanDialog
    v-model="dialogVisible"
    :current-plan="store.dialogData.currentPlan"
    :base-entities="store.dialogData.baseEntities"
    :existing-additional="store.dialogData.existingAdditional"
    :entity-usage="store.dialogData.entityUsage"
    :trial-days-remaining="store.dialogData.trialDaysRemaining"
    :renewal-mode="store.renewalMode"
    :billing-period="store.dialogData.billingPeriod"
    :billing-email="store.dialogData.billingEmail"
    :billing-contact-name="store.dialogData.billingContactName"
    :required-entities="store.requiredEntities"
    :proration-remaining-days="store.dialogData.prorationRemainingDays"
    :proration-total-days="store.dialogData.prorationTotalDays"
    :subscription-end-date="store.dialogData.subscriptionEndDate"
    @plan-updated="handlePlanUpdated"
  />
</template>
